import { getImage, getText } from "./siteConfig";
import { useBaseStore } from "@store/base";
import { HOST } from "@api/request";
export const iframeConfig = {
  // 站点标识
  // 台港澳版空之要塞
  sfqhguide: [
    {
      // iframe地址
      url: `https://gevents.${HOST}/sfqhguide/index.html`,
      // 导航配置
      nav: {
        ico: getImage("tools.png"),
        textKey: "zhenrong",
      },
      // 首页分类配置
      class: {
        ico: getImage("sfqhguide-class.png"),
        textKey: "zhenrong",
      },
    },
  ],
  // 站点标识
  // 日语版空之要塞
  sfojpguide: [
    {
      // iframe地址
      url: `https://gevents.${HOST}/sfqhguide/index.html`,
      // 导航配置
      nav: {
        ico: getImage("tools.png"),
        textKey: "zhenrong",
      },
      // 首页分类配置
      class: {
        ico: getImage("sfqhguide-class.png"),
        textKey: "zhenrong",
      },
    },
  ],
  // 全球版（韩语版）
  kzysglguide: [
    {
      // iframe地址
      url: `https://gevents.${HOST}/sfqhguide/index.html`,
      // 导航配置
      nav: {
        ico: getImage("tools.png"),
        textKey: "zhenrong",
      },
      // 首页分类配置
      class: {
        ico: getImage("sfqhguide-class.png"),
        textKey: "zhenrong",
      },
    },
  ],
};

export const transformModuleConfig = (moduleConfig, name) => {
  const base = useBaseStore();
  const config = iframeConfig[name];
  config.forEach((item, index) => {
    const key = `${name}_embed_${index}`;
    moduleConfig.push({
      MODULE_ICON: item?.nav?.ico || "",
      MODULE_ICON_HIGHLIGHT: item?.nav?.ico || "",
      MODULE_NAME_MULTILINGUAL: JSON.stringify({
        [base.lang]: getText(item.nav.textKey),
      }),
      ID: Date.now(),
      MODULE_TYPE: 999,
      STATE: 1,
      MODULE_ENNAME: key,
      IS_NAV: 1,
      MODULE_PATH: `/${key}`,
      iframeUrl: item.url,
      isIframe: true,
    });
  });
  console.log(moduleConfig);
};
